// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--epb4y","label":"_4f720283bf--label--WM3kI"};